export const JACKETS_SLUG = 'jackets';
export const TROUSERS_SLUG = 'trousers';
export const SHIRTS_SLUG = 'shirts';
export const SUITS_SLUG = 'suits';

export const JACKETS_CATEGORY_NAME = 'Jackets';
export const TROUSERS_CATEGORY_NAME = 'Trousers';
export const SHIRTS_CATEGORY_NAME = 'Shirts';
export const SUITS_CATEGORY_NAME = 'Suits';

export const UPPER_BODY_SLUG = 'upper-body';
export const LOWER_BODY_SLUG = 'lower-body';

export const UPPER_BODY_NAME = 'Upper Body';
export const LOWER_BODY_NAME = 'Lower Body';
